import React, { CSSProperties, FC } from 'react'
import { useFormikContext, Field } from 'formik'

type Props = {
    type: 'text' | 'email' | 'password',
    placeholder?: string,
    name: string,
    disabled?: boolean,
    value?: string | number,
    className?: string,
    onChange?: (e) => any,
    maxLength?: number,
    onKeyDown?: (e) => any,
    fieldStyle?: CSSProperties,
    validation?: (value: string) => string | undefined,
    innerRef?: (element) => void
}


const Input: FC<Props> = ({ type, placeholder = '', name = '', disabled = false, children, value, className ='flex flex-row items-center p-1 border text-gray-800 ', onChange, maxLength, onKeyDown, fieldStyle, validation, innerRef }) => {
    const { handleChange } = useFormikContext();

    return (
        <div className={`${className} ${disabled ? "bg-gray-input" : ""}`}>
            {children}
            {value // Specifying a value on the Field component leads to strange behaviours with bound data.
                ? <Field
                    className={disabled ? "px-1 bg-gray-input w-full cursor-not-allowed" : "px-1 bg-transparent w-full"}
                    disabled={disabled}
                    type={type}
                    name={name}
                    placeholder={placeholder}
                    value={value}
                    maxLength={maxLength}
                    onChange={onChange ? onChange : handleChange}
                    style={fieldStyle}
                    innerRef={innerRef} />
                : <Field
                    className={disabled ? "px-1 bg-gray-input w-full cursor-not-allowed" : "px-1 bg-transparent w-full"}
                    disabled={disabled}
                    type={type}
                    name={name}
                    placeholder={placeholder}
                    maxLength={maxLength}
                    onChange={onChange ? onChange : handleChange}
                    onKeyDown={onKeyDown}
                    style={fieldStyle}
                    validate={validation}
                    innerRef={innerRef} />
            }
        </div>
    )
}

export default Input



